<template>
    <div class="lanes-container">
        <div class="sticky-icon">
            <Location class="lane-location-icon" />
        </div>
        <div class="lanes-wrapper">
            <div v-for="area in areas" :key="area.name" class="lane-wrapper">
                <span class="lane-name">{{ area.name }}</span>
                <span class="lane-issues">{{ area.issues }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import Location from '../../../../icons/Location.vue';

const props = defineProps({
    areas: {
        type: Array,
        required: true,
    },
});
</script>

<style scoped>
.lanes-container {
    position: relative;
    display: flex;
    align-items: center;
    border-radius: 6px;
    background: var(--Light-BG-Blue, #f2f5fa);
}

.sticky-icon {
    position: sticky;
    left: 0;
    z-index: 1;
    background: var(--Light-BG-Blue, #f2f5fa);
    padding: 0 5px;
}

.lanes-wrapper {
    display: flex;
    align-items: center;
    flex-grow: 1;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: thin;
    -webkit-overflow-scrolling: touch;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.lanes-wrapper::-webkit-scrollbar {
    height: 4px;
}

.lanes-wrapper::-webkit-scrollbar-track {
    background: transparent;
}

.lanes-wrapper::-webkit-scrollbar-thumb {
    background: var(--Light-Grey, #e4e5e6);
    border-radius: 4px;
}

.lane-location-icon {
    margin: 10px;
    height: 20px;
    width: 20px;
}

.lane-wrapper {
    display: inline-flex;
    padding: 4px 4px 4px 14px;
    align-items: center;
    gap: 16px;
    border-radius: 222px;
    background: var(--White, #fff);
    margin-right: 8px;
}

.lane-name {
    color: var(--Horizon-Haze, #8490a1);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0.286px;
}

.lane-issues {
    display: flex;
    width: 24px;
    height: 24px;
    justify-content: center;
    align-items: center;
    aspect-ratio: 1;
    border-radius: 50%;
    background: var(--Light-Red, #ffecec);
    color: var(--Dark-Red, #be4141);
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
</style>
